import styled from "styled-components";
import Logo from "../../../assets/images/BOstageRLogo.png";

import RightChevron from "../../../assets/images/rigthChevron.png";
import Formula from "../../../assets/images/formula.png";
import { useState } from "react";
const StylePage = styled.div`
    .frame-1000011043,
    .frame-1000011043 * {
        box-sizing: border-box;
    }
    .frame-1000011043 {
        background: linear-gradient(180deg, rgba(255, 170, 0, 0.2) 0%, rgba(12, 12, 12, 0.2) 20%),
            linear-gradient(to left, #141922, #141922);
        border-radius: 16px;
        padding: 68.54px 20px 39.17px 32px;
        display: flex;
        flex-direction: column;
        gap: 19.58px;
        align-items: center;
        justify-content: center;
        position: absolute;
        overflow: hidden;
        width: 1200px;
        top: 3%;
        z-index: 9999;
        height: 100%;
    }
    .frame-1000011045 {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        height: 100%;
    }
    .frame-1000011394 {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011186 {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011178 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .b-ostage-b-2 {
        flex-shrink: 0;
        width: 159.12px;
        height: 44.06px;
        position: relative;
        object-fit: cover;
    }
    .text {
        color: #d1d1d1;
        text-align: center;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 16px;
        line-height: 25.42px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .frame-1000011179 {
        display: flex;
        flex-direction: column;
        gap: 29.38px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011180 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .text2 {
        background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(153, 153, 153, 1) 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        font-family: "Roboto-SemiBold", sans-serif;
        font-size: 30px;
        font-weight: 600;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .frame-1000011390 {
        display: flex;
        flex-direction: row;
        gap: 32px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011396 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        transform-origin: 0 0;
        transform: rotate(0deg) scale(-1, 1);
        padding: 20px;
    }
    .frame-1000011388 {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 9999px;
        padding: 4px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011389 {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 9999px;
        padding: 4px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: absolute;
        left: -12px;
    }
    .chevron-right {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
        cursor: pointer;
    }
    .frame-1000011395 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-10000113962 {
        display: grid;
        grid-auto-flow: column;
        grid-template-rows: repeat(2, auto);
        grid-template-columns: repeat(3, auto);
        gap: 24px;
        align-items: flex-start;
        align-self: stretch;
        position: relative;
        height: 583px;
    }
    .frame-10000113555 {
        display: grid;
        grid-template-rows: repeat(2, auto);
        grid-template-columns: repeat(3, auto);
        gap: 18px;
        align-items: flex-start;
        align-self: stretch;
        position: relative;
    }
    .frame-1000011182 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-1000011187 {
        border-radius: 10px;
        align-self: stretch;
        flex-shrink: 0;
        height: 145px;
        position: relative;
        overflow: visible;
    }
    .text3 {
        color: #d1d1d1;
        text-align: left;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 14px;
        line-height: 18px;
        font-weight: 700;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .text4 {
        color: #d1d1d1;
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        line-height: 17.5px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .frame-1000011183 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-10000111872 {
        background: #1e2631;
        border-radius: 10px;
        align-self: stretch;
        flex-shrink: 0;
        height: 145px;
        position: relative;
        overflow: hidden;
    }
    .group-1000011032 {
        height: 80.66%;
        position: absolute;
        inset: 11.51% 9.7% 17.82%;
        overflow: visible;
    }
    .group-10000110000 {
        height: 80.66%;
        position: absolute;
        inset: 11.51% 9.7% 17.82% 6%;
        overflow: visible;
    }
    .frame-1000011397 {
        display: flex;
        flex-direction: row;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .group-1000011033 {
        height: 80.66%;
        position: absolute;
        inset: 11.51% 9.7% 17.82%;
        overflow: visible;
    }
    .group-1000011034 {
        height: 80.66%;
        position: absolute;
        inset: 11.51% 9.7% 17.82%;
        overflow: visible;
    }
    .frame-1000011279 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .chevron-right2 {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
        cursor: pointer;
    }
    .frame-1000011392 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011391 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011393 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .ellipse-3 {
        background: var(--bostager-orange-active, #d37e00);
        border-radius: 50%;
        flex-shrink: 0;
        width: 14px;
        height: 14px;
        position: relative;
        cursor: pointer;
    }
    .ellipse-2 {
        background: var(--backgrounds-and-lines-n-200, #262e3e);
        border-radius: 50%;
        flex-shrink: 0;
        width: 14px;
        height: 14px;
        position: relative;
        cursor: pointer;
    }
    .x-close {
        flex-shrink: 0;
        width: 45px;
        height: 45px;
        position: absolute;
        right: 16px;
        top: 16px;
        overflow: visible;
        aspect-ratio: 1;
    }
    .close-icon {
        border-radius: 5px;
        display: flex;
        width: 40px;
        height: 40px;
        padding: 4px 8px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        cursor: pointer;
        font-size: 25px;
    }
    .disabled {
        opacity: 0.5;
        pointer-events: none;
    }
    .formula {
        width: 100px;
        height: 20px;
    }

    .frame-1000011184,
    .frame-1000011184 * {
        box-sizing: border-box;
    }
    .frame-1000011184 {
        background: #1e2631;
        border-radius: 10px;
        padding: 94px 24px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-1000011442 {
        display: flex;
        flex-direction: column;
        gap: 52px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .text6 {
        color: var(--text-and-icons-orange-500, #ff9900);
        text-align: center;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 24px;
        letter-spacing: -0.015em;
        font-weight: 400;
        text-transform: uppercase;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .text7 {
        color: #d1d1d1;
        text-align: justified;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 18px;
        line-height: 24px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        line-height: 19px;
    }
`;

const StandardStockPopup = ({ featureCards, setShowStockPopup, extraCards, showStockPopup }) => {
    const [startIndex, setStartIndex] = useState(0);
    const visibleCards = featureCards.slice(startIndex, startIndex + 4);
    const hasNext = startIndex + 4 < featureCards.length;
    const hasPrevious = startIndex > 0;

    const handleNext = () => {
        if (startIndex + 4 < featureCards.length) {
            setStartIndex(prev => prev + 4);
        }
    };
    const handlePrevious = () => {
        if (startIndex - 4 >= 0) {
            setStartIndex(prev => prev - 4);
        }
    };
    return (
        <StylePage style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div className="frame-1000011043">
                <div className="frame-1000011045">
                    <div className="frame-1000011394">
                        <div className="frame-1000011186">
                            <div className="frame-1000011178">
                                <img alt="" className="b-ostage-b-2" src={Logo} />
                                <div className="text">the BOtag B2B platform for Retailers</div>
                            </div>
                            <div className="frame-1000011179">
                                <div className="frame-1000011180">
                                    {showStockPopup.smartDataPopup ? (
                                        <>
                                            <div className="text2">
                                                Not Sure? Unlock the Benefits of Smart Data Sharing
                                            </div>
                                            <div className="text">
                                                Share your stock data to enable real-time reorders and targeted
                                                promotions that boost sales, reduce waste, and streamline your inventory
                                                management
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="text2">Extra Conditions</div>
                                            <div className="text">
                                                The conversion-based metric is designed to ensure that Label Brands are
                                                actively driving consumer engagement and <br /> generating sales through
                                                BOimages to keep their access to your stock data.
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="frame-1000011390">
                            {showStockPopup.smartDataPopup ? (
                                <div className="frame-1000011396">
                                    <div
                                        className={`frame-1000011389 ${!hasPrevious ? "disabled" : ""}`}
                                        onClick={hasPrevious ? handlePrevious : null}>
                                        <img alt="" className="chevron-right" src={RightChevron} />
                                    </div>
                                </div>
                            ) : null}

                            <div className="frame-1000011395">
                                <div className="frame-10000113962">
                                    {showStockPopup.smartDataPopup ? (
                                        visibleCards.map(card => (
                                            <FeatureCard
                                                imageSrc={card.imageSrc}
                                                description={card.description}
                                                title={card.title}
                                                showStockPopup={showStockPopup}
                                            />
                                        ))
                                    ) : (
                                        <div
                                            className={
                                                showStockPopup.smartDataPopup
                                                    ? "frame-10000113962"
                                                    : "frame-10000113555"
                                            }>
                                            {extraCards.map((card, index) => (
                                                <FeatureCard
                                                    index={index}
                                                    imageSrc={card.imageSrc}
                                                    description={card.description}
                                                    title={card.title}
                                                />
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {showStockPopup.smartDataPopup && (
                                <div className="frame-1000011279">
                                    <div
                                        className={`frame-1000011388 ${!hasNext ? "disabled" : ""}`}
                                        onClick={hasNext ? handleNext : null}>
                                        <img alt="" className="chevron-right2" src={RightChevron} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {showStockPopup.smartDataPopup && (
                        <div className="frame-1000011392">
                            <div className={`${startIndex - 4 >= 0 ? "frame-1000011391" : "frame-1000011393"}`}>
                                <div
                                    className={`${startIndex === 0 ? "ellipse-3" : "ellipse-2"}`}
                                    onClick={handlePrevious}></div>
                                <div
                                    className={`${startIndex === 0 ? "ellipse-2" : "ellipse-3"}`}
                                    onClick={handleNext}></div>
                            </div>
                        </div>
                    )}
                </div>

                <div
                    className="x-close close-icon"
                    onClick={prev =>
                        setShowStockPopup({
                            ...prev,
                            smartDataPopup: false,
                            extraDataPopup: false
                        })
                    }>
                    <i className="fa-light">X</i>
                </div>
            </div>
        </StylePage>
    );
};

export default StandardStockPopup;

const FeatureCard = ({ imageSrc, title, description, showStockPopup, index }) => {
    return (
        <div className="frame-1000011182">
            {index !== 5 ? (
                <>
                    <div className="frame-10000111872">
                        <img
                            alt=""
                            className={`${showStockPopup?.smartDataPopup ? "group-1000011032" : "group-10000110000"}`}
                            src={imageSrc}
                        />
                    </div>
                    <div className="text3">{title}</div>
                    <div className="text4">{description}</div>
                </>
            ) : (
                <div class="frame-1000011184">
                    <div class="frame-1000011442">
                        <div className="text6">{title}</div>
                        <div className="text4">{description}</div>
                    </div>
                </div>
            )}

            {index === 3 && (
                <>
                    <img alt="" src={Formula} className="formula" />
                    <div>This means that for every 100 times the BOimage is viewed, 3 sales are generated.</div>
                </>
            )}
        </div>
    );
};
